export default __webpack_public_path__ + "static/media/deligoo-light.e173df92.svg";